export default __webpack_public_path__ + "static/media/contact_icon.58e19a8c.svg";